import React from 'react'
import styles from './LbHero.module.css'
import { motion } from 'framer-motion'
import { Link } from 'react-router'

const LbHero = () => {
    return (
        <section className={styles.hero}>
            <div className={styles.contentWrapper}>
                <div className={styles.textSection}>
                    <motion.h1
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        Supercharge Your Website Forms<br />
                        with <span className={styles.highlight}>LeadBridge™</span>
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.6 }}
                    >
                        Automatically capture leads, appointments, and enquiries directly into your CRM — in real-time, securely, and with full analytics.
                    </motion.p>
                    <div className={styles.ctaButtons}>
                        <Link to="/leadbridge/get-started" className={styles.primaryBtn}>Get Started</Link>
                        <Link to="/leadbridge/dashboard" className={styles.secondaryBtn}>Go To Dashboard</Link>
                        {/* <a href="#how-it-works" className={styles.secondaryBtn}>See How It Works</a> */}
                    </div>
                </div>
                <motion.div
                    className={styles.visualSection}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                >
                    <img src="https://sm.lokaci.com/assets/lb-flow.png" alt="LeadBridge Flow" />
                </motion.div>
            </div>
        </section>
    )
}

export default LbHero
